import type { Environment } from './types';

export const production: Environment = {
  name: 'production',
  apiBaseUrl: 'https://api.runqo.app',
  mapboxAccessToken:
    'pk.eyJ1IjoiZHVzaGFucGFudGljIiwiYSI6ImNtaXVzcmwxNzAxbTgzaHI1OWF0ZXQxbDkifQ.1NjudjryWTMAA6gT2iOXPg',
  firebase: {
    apiKey: 'AIzaSyDYEBzq4o3lbJ4Pi4Idm4oYw9s-Bt_lA8I',
    authDomain: 'runqo-app-prod.firebaseapp.com',
    projectId: 'runqo-app-prod',
    storageBucket: 'runqo-app-prod.firebasestorage.app',
    messagingSenderId: '177883512711',
    appId: '1:177883512711:web:78d9be77053ca994cd5d22',
    measurementId: 'G-N08XCQ3YFE',
  },
  features: { registration: false, openSignUp: false },
};
